<app-header-content ></app-header-content>
<app-pagecontent [path]="'realtime'"></app-pagecontent>
  <ion-grid  style="padding: 0">
    <ion-row>
      <ion-col style="padding:0;margin: 0;background:white;" size="12">
        <h2 class="subheader-regular" style="text-align: center;">
          {{('keys.data.permits.parking_map' | translate) || 'Parking map'}}
        </h2> 
      </ion-col>
    </ion-row>
    <ion-row style="background: #FFF;">
      <ion-col sizeXs="12" sizeSm="10" offsetSm="1" sizeMd="7" offsetMd="0" sizeLg="6" offsetLg="1"  style="padding: 0;" [ngStyle]="{'background': color}" >
        <app-loading-spinner  *ngIf="!loaded"></app-loading-spinner>
        <capacitor-google-map [style.height.px]="platformSRV.width<environment.maxMobileWidth ? height*0.55 : height" #map ></capacitor-google-map>
      </ion-col>
      <ion-col style="background: #FFF;" sizeXs="12" sizeSm="10" offsetSm="1" sizeMd="5" offsetMd="0" sizeLg="4"   >
        <ion-grid style="padding: 0;">
          <ion-row >
            <ion-col style="padding: 0;"> 
              <ion-item lines="none">
              <ion-label (click)="showIconLegend()" style="font-weight: bold;cursor: pointer;">{{ ('keys.data.permits.icon_legend' |
                translate : {Default:'Icon Legend'}) || 'Icon Legend' }}<ion-icon name="alert-circle-outline" style="font-size: large; vertical-align: middle;margin-left: 0.5em;"></ion-icon></ion-label>
              </ion-item>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col style="padding:0;margin: 0;background:white;">
              <ion-card  style="border-radius: 35px 35px 0px 0px;width: 100%;margin: 0;">
                <ion-grid >
                  
                  <ion-row *ngIf="loaded && lots.length>0">
                    <ion-col>
                      <ion-item lines="none" style="--background:transparent">
                      <ion-label class="paragraph-input-fields-bold">{{ ('keys.data.admin_menu.parking_lot' |
                        translate : {Default:'Parking Lot'}) || 'Parking Lot' }}</ion-label>
                      </ion-item>
                    </ion-col>
                  </ion-row>
                  <ion-row *ngIf="loaded && lots.length>0">
                    <ion-col>
                      <ion-card class="card-shadow-3">
                        
                        <ion-row >
                          <ion-col style="text-align: center;">
                            <ion-item lines="none" >
                              
                              <ion-select style="white-space: normal; font-size: large" [interface]="platformSRV.interface" [mode]="platformSRV.mode" (ionChange)="selected($event)" (ngModel)="selectedLot" multiple="false" [selectedText]="selectedLot.name">
                                <ion-select-option *ngFor="let lot of lots" [value]="lot.id" >{{lot.name}}</ion-select-option>
                              </ion-select>
                            </ion-item>
                            
                            
                          </ion-col>
                        </ion-row>
                       
                      </ion-card>
                    </ion-col>
                  </ion-row>
                  
                  
                   <ion-row >
                    <ion-col>
                     
                        <ion-grid class="ion-no-padding">
                          <ion-row>
                            <ion-col style="text-align: center">
                              <ion-card class="card-shadow-7">
                                <ion-card-content>
                                  <app-loading-spinner  *ngIf="!loaded"></app-loading-spinner>
                                  <ion-row>
                                    <ion-col style="text-align: center;font-weight: bold" size="8" offset="2">
                                      
                                      <ion-label class="paragraph-input-fields-bold" style=" white-space: normal;">{{selectedLot?.location}}</ion-label>
                                    </ion-col>
                                   </ion-row>
                              <ion-row>
                                <ion-col size="10" offset="1">
                                  <div class="chartDiv" >
                                    <canvas  #myChart></canvas>
                                  </div>
                                </ion-col>
                              </ion-row>
                            </ion-card-content>
                            </ion-card>
                            </ion-col>
                          </ion-row>
                          <ion-row *ngIf="loaded && lots.length>0">
                            <ion-col>
                              <ion-card class="card-shadow-7">
                               
                                <ion-grid style="padding: 0;">
                                  <ion-row *ngIf="(!disableHourly || !disableDaily)">
                                    <ion-col style="padding: 0;">
                                      <ion-segment
                                       color="dark"
                                      (ionChange)="onSectionChange($event)"
                                      scrollable="true"
                                      style="--background:var(--Gray-300, #F2F2F2);"
                                    >
                                    <ion-segment-button style="--background:var(--Gray-300, #F2F2F2);"  value="hourly" [disabled]="disableHourly">
                                      <ion-label>{{('keys.data.permits.temporary_hourly' |
                                        translate : {Default:'Hourly'}) || 'Hourly' }}</ion-label>
                                    </ion-segment-button>
                                      <ion-segment-button  [disabled]="disableDaily" value="daily" style="--background:var(--Gray-300, #F2F2F2);">
                                        <ion-label>{{('keys.data.permits.temp_daily' |
                                          translate : {Default:'Daily'}) || 'Daily' }}</ion-label>
                                      </ion-segment-button>
                                    </ion-segment>
                                    <div [ngSwitch]="permitType">
                                      <ng-container *ngSwitchCase="'daily'">
                                        <ion-grid>
                                          <ion-row >
                                            <ion-col  style="max-height: 27vh;overflow-y: auto;padding: 0
                                        ; text-align: center" >
                                        <ion-list>
                                        <ion-item lines="none" class="paragraph-input-fields-regular"
                                      >
                                            <ion-label
                                            class="ion-text-wrap"
                                          >
                                          {{('keys.data.permits.temp_daily' |
                                          translate : {Default:'Daily'}) || 'Daily' }}
                                          </ion-label>
                                          <ion-label
                                            class="ion-text-wrap"
                                            style="text-align: right"
                                          >
                                          {{selectedLot.daily|
                                            currency}}
                                          </ion-label>
                                        </ion-item>
                                      </ion-list>
                                            </ion-col>
                                          </ion-row>
                                        </ion-grid>
      
                                      </ng-container>
                                      <ng-container *ngSwitchCase="'hourly'">
                                        <ion-grid>
                                          <ion-row>
                                            <ion-col  style="max-height: 27vh;overflow-y: auto;padding: 0
                                        ; text-align: center" >
                                              <ion-list>
                                               
                                              <div *ngIf="selectedLot.hours.length>4" style="text-align: center;cursor: pointer;"><ion-icon (click)="scrollToBottom()" name="chevron-down" size="small"></ion-icon></div>
                                              <ion-item lines="none" class="paragraph-input-fields-regular"
                                                *ngFor="let hour of selectedLot.hours; let i=index" id="hour{{i+1}}"
                                              >
                                                <ion-label
                                                  class="ion-text-wrap"
                                                  *ngIf="hour.duration<2"
                                                >
                                                  {{hour.duration}} {{ ('keys.data.permits.temporary_hour' |
                                                  translate : {Default:'Hour'}) || 'Hour' }}
                                                </ion-label>
                                                <ion-label
                                                  class="ion-text-wrap"
                                                  *ngIf="hour.duration>1"
                                                >
                                                  {{hour.duration}} {{ ('keys.data.permits.temporary_hours' |
                                                  translate : {Default:'Hours'}) || 'Hours' }}
                                                </ion-label>
                                                <ion-label
                                                  class="ion-text-wrap"
                                                  style="text-align: right"
                                                  >{{hour.price |
                                                  currency}}</ion-label
                                                >
                                              </ion-item>
                                              <div *ngIf="selectedLot.hours.length>4" style="text-align: center;cursor: pointer;"><ion-icon (click)="scrollToTop()" name="chevron-up" size="small"></ion-icon></div>
                                            </ion-list>
                                            </ion-col>
                                          </ion-row>
                                        </ion-grid>
                                      </ng-container>
                                      </div>
                                    </ion-col>
                                   
                                  </ion-row>
                                  
                                </ion-grid>
                              </ion-card>
                            </ion-col>
                          </ion-row>
                          <ion-row *ngIf="loaded && selectedLot?.spaces.length>0">
                    
                            <ion-col style="text-align: center;text-align: center;" >
                                      <ion-card>
                                        <ion-card-content>
                              <ion-grid>
                                <ion-row >
                                  <ion-col  style="padding: 0
                              ; text-align: center" >
                                  <h2  class="ion-text-wrap">
                                    {{ ('keys.data.permits.special_spaces' |
                                    translate : {Default:'Special Parking Spaces'}) || 'Special Parking Spaces' }}
                                  </h2>
                                  <ion-list>
                                    <ion-item lines="none"
                                      *ngFor="let space of selectedLot.spaces; let i=index" id="hour{{i+1}}"
                                    >
                                    <ion-label
                                    class="ion-text-wrap"
                                   
                                  >
                                {{space.space_type.type_name}} 
                                </ion-label>
                                <ion-label class="ion-text-wrap"
                                style="text-align: right"> {{space.amount}}</ion-label>
                                    </ion-item>
                                  </ion-list>
                                  </ion-col>
                                  </ion-row>
                                  </ion-grid>
                                </ion-card-content>
                                </ion-card>
                                      
                              
                            </ion-col>
                          </ion-row>
                        </ion-grid>
                        
                      
                    </ion-col>
                   </ion-row>
                 
                  <ion-row *ngIf="loaded && lots.length>0">
                    <ion-col   style="text-align: center;">
                      <ion-label class="paragraph-input-fields-bold" *ngIf="selectedLot.password_enabled" > {{ ('keys.data.permits.lot_password_required' | translate )}}</ion-label>
                      <ion-button style="font-weight: bold;" [disabled]="selectedLot.stats.tempFreePercent<=0 || (disableHourly && disableDaily)"  color="primary" (click)="BookNow(selectedLot)" >{{ ('keys.data.permits.book_now' |
                        translate : {Default:'Book Now'}) || 'Book Now' }}  <ion-icon *ngIf="selectedLot.password_enabled" name="lock-closed"></ion-icon></ion-button>
                    </ion-col>
                  </ion-row>
                  <ion-row *ngIf="loaded && lots.length>0">
                    <ion-col style="text-align: center;">
                      <ion-button style="font-weight: bold;"  color="primary" fill="outline" (click)="openInMaps()">{{ ('keys.data.permits.get_directions' |
                        translate : {Default:'Get directions to lot'}) || 'Get directions to lot' }}</ion-button>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ion-card>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-footer class="ion-no-border">
    <app-footer></app-footer>
  </ion-footer>